import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

// actions
import { doneIndicator, error } from '../../actions/standardActions';

// api
import doctorAPI from '../../sources/api/doctorAPI';

// constants
import { DOCTOR_EDIT } from '../../constants/doctorTypes';

// lib
import handleServerValidation from '../../lib/handleServerValidation';
import httpSaga from '../../lib/httpSaga';

// schemas
import { doctorSchema } from '../../schemas/Normalizr';
import { tooltipHide } from '../../actions/tooltipActions';
import { toastr } from 'react-redux-toastr';
import { DOCTOR_EDIT_ERROR, DOCTOR_EDIT_SUCCESS } from '../../constants/messages';

export function* doctorEdit(action) {
  if (action['@@redux-saga/SAGA_ACTION']) return;

  const params = action.payload;

  params.currentWeeklySchedule = {
    monday: params.inOfficeMonday,
    tuesday: params.inOfficeTuesday,
    wednesday: params.inOfficeWednesday,
    thursday: params.inOfficeThursday,
    friday: params.inOfficeFriday
  };

  try {
    yield *httpSaga(DOCTOR_EDIT, call(doctorAPI.edit, params), doctorSchema);
    yield put(tooltipHide({ id: params.tooltipId }));
    yield toastr.success('success', DOCTOR_EDIT_SUCCESS);
  } catch (e) {
    const errors = handleServerValidation('doctor', e.response.body.details, { nestedPath: true });

    yield toastr.error(DOCTOR_EDIT_ERROR);
    yield put(error(DOCTOR_EDIT, errors));
  } finally {
    yield put(doneIndicator(DOCTOR_EDIT));
  }
}

export function* watchDoctorEdit() {
  yield takeEvery(DOCTOR_EDIT, doctorEdit);
}

export default function* root() {
  yield all([
    fork(watchDoctorEdit)
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/doctor/doctorEdit.js